module.exports = __webpack_public_path__ + "img/benjamin-franklin-palmer.366deadd.png";